var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5H9.5V2C9.5 1.44781 9.05219 1 8.5 1H7.5C6.94781 1 6.5 1.44781 6.5 2V6.5H2C1.44781 6.5 1 6.94781 1 7.5V8.5C1 9.05219 1.44781 9.5 2 9.5H6.5V14C6.5 14.5522 6.94781 15 7.5 15H8.5C9.05219 15 9.5 14.5522 9.5 14V9.5H14C14.5522 9.5 15 9.05219 15 8.5V7.5C15 6.94781 14.5522 6.5 14 6.5Z",
    fill: "#242932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bf920800a62b4a7325fdacbadb880aa0.svg";
export { ForwardRef as ReactComponent };